import * as React from "react";
import { InputGroup, InputGroupAddon, InputGroupInput, InputGroupText } from "@shared-kernel/primary/shared/shadcn/ui/input-group";

interface CurrencyInputProps extends Omit<React.ComponentProps<"input">, "type" | "onChange" | "value"> {
  value: number | "";
  onChange: (value: number | "") => void;
  currency?: string;
}

const CurrencyInput = React.forwardRef<HTMLInputElement, CurrencyInputProps>(
  ({ className, value, onChange, currency = "€", ...props }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const inputValue = e.target.value;
      onChange(inputValue === "" ? "" : Number(inputValue));
    };

    return (
      <InputGroup className={className}>
        <InputGroupInput
          type="number"
          ref={ref}
          value={value === "" ? "" : value}
          onChange={handleChange}
          onWheel={e => e.currentTarget.blur()}
          {...props}
        />
        <InputGroupAddon align="inline-end">
          <InputGroupText>{currency}</InputGroupText>
        </InputGroupAddon>
      </InputGroup>
    );
  },
);

CurrencyInput.displayName = "CurrencyInput";

export { CurrencyInput };
